const actions = {
  Assign: {
    id: 'assignAgent',
    title: 'Agent Assign',
    icon: 'agent',
    permission: ['services.actions.assign']
  },
  AssignCanceledPickup: {
    id: 'assignCanceledPickup',
    title: 'Assign',
    icon: 'agent',
    permission: ['services.actions.assign']
  },
  ReassignCanceledDropoff: {
    id: 'reassignCanceledDropoff',
    title: 'Revert',
    icon: 'assign-outline',
    permission: ['services.actions.assign']
  },
  AutoAssign: {
    id: 'autoAssignAgent',
    title: 'Auto Assign Agent',
    icon: 'assign-outline',
    permission: ['services.actions.assign']
  },
  AssignRoute: {
    id: 'assignRoute',
    title: 'Add To Route',
    icon: 'route',
    permission: ['routes.list']
  },
  AssignResourceAllocation: {
    id: 'assignResourceAllocation',
    title: 'Add To Resource',
    icon: 'allocation',
    permission: ['fleetManagement.allocations.list']
  },
  Auction: {
    id: 'auction',
    title: 'Auction',
    icon: 'dollar-circle',
    permission: ['market.create']
  },
  Reset: {
    id: 'reset',
    title: 'Reset',
    icon: 'reset',
    permission: ['services.actions.reset']
  },
  Cancel: {
    id: 'cancel',
    title: 'Cancel',
    icon: 'close-circle-outline',
    permission: ['services.actions.delete']
  },
  SendToMarket: {
    id: 'sendToMarket',
    title: 'SendToMarket',
    icon: 'market-outline',
    permission: ['market.create']
  },
  ManualHandle: {
    id: 'manualHandle',
    title: 'ManualHandle',
    icon: 'check-circle-outline',
    permission: ['services.actions.manual']
  },
  Note: {
    id: 'note',
    title: 'AddNote',
    icon: 'note',
    permission: ['services.actions.notes']
  },
  BulkSMS: {
    id: 'bulkSMS',
    title: 'bulkSMS',
    icon: 'message-outline',
    permission: ['sms.send']
  },
  CreateRoute: {
    id: 'createRoute',
    title: 'Create Route',
    icon: 'route',
    permission: ['routes.list']
  },
  Edit: {
    id: 'edit',
    title: 'Edit',
    icon: 'edit-outline',
    permission: ['services.update']
  },
  EditTimeWindow: {
    id: 'editTimeWindow',
    title: 'EditTimeWindow',
    icon: 'time-window-outline',
    permission: ['services.update']
  },
  EditLocation: {
    id: 'editLocation',
    title: 'EditLocation',
    icon: 'edit-outline',
    permission: ['services.update']
  },
  SendToPlanning: {
    id: 'sendToPlanning',
    title: 'Send To Planning',
    icon: 'planning',
    permission: ['planning.servicePlanning.create']
  },
  Duplicate: {
    id: 'duplicate',
    title: 'Duplicate',
    icon: 'duplicate-outline',
    permission: ['orders.create', 'orders.delivery.create']
  },
  Print: {
    id: 'print',
    title: 'Print',
    icon: 'print',
    permission: ['services.list']
  },
};

const serviceActions = {
  Assign: actions.Assign,
  AssignCanceledPickup: actions.AssignCanceledPickup,
  ReassignCanceledDropoff: actions.ReassignCanceledDropoff,
  AutoAssign: actions.AutoAssign,
  AssignRoute: actions.AssignRoute,
  AssignResourceAllocation: actions.AssignResourceAllocation,
  Auction: actions.Auction,
  Reset: actions.Reset,
  Cancel: actions.Cancel,
  SendToMarket: actions.SendToMarket,
  ManualHandle: actions.ManualHandle,
  CreateRoute: actions.CreateRoute,
  Edit: actions.Edit,
  Duplicate: actions.Duplicate,
  Note: actions.Note,
  BulkSMS: actions.BulkSMS,
  EditLocation: actions.EditLocation,
  SendToPlanning: actions.SendToPlanning
};

export const servicesExtraActions = {
  Dispatch_External: {
    id: 'dispatchExternal',
    title: 'Move To External Dispatch',
    icon: 'dispatch'
  },
  Edit_Delivery: {
    id: 'edit',
    title: 'Edit',
    icon: 'edit-outline',
    permission: ['services.update', 'services.delivery.update']
  },
  Edit_Operation: {
    id: 'edit',
    title: 'Edit',
    icon: 'edit-outline',
    permission: ['services.update', 'services.operation.update']
  },
  Duplicate_Delivery: {
    id: 'Duplicate',
    title: 'Duplicate',
    icon: 'duplicate-outline',
    permission: ['orders.create', 'orders.delivery.create']
  },
  Duplicate_Operation: {
    id: 'Duplicate',
    title: 'Duplicate',
    icon: 'duplicate-outline',
    permission: ['orders.create', 'orders.operation.create']
  },
  Print: {
    id: 'Print',
    title: 'Print',
    icon: 'print',
    permission: ['services.list']
  },
  CreateExpense: {
    id: 'CreateExpense',
    title: 'Create Expense',
    icon: 'dollar',
    permission: ['expenses.create']
  },
  PrintLabel: {
    id: 'PrintLabel',
    title: 'Print Label',
    icon: 'print',
    permission: ['services.list']
  },
  PrintIkea: {
    id: 'PrintIkea',
    title: 'Print Ikea',
    icon: 'print',
    permission: ['printers.list']
  }
};

export const serviceActionsByStatusMap = {
  Operation: {
    InAuction: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning
    ],
    InMarket: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning
    ],
    Assigned: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning
    ],
    Unassigned: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning
    ],
    Started: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning
    ],
    Aborted: [
      serviceActions.Reset,
      serviceActions.AssignCanceledPickup,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation
    ],
    Completed: [
      serviceActions.Note,
      serviceActions.BulkSMS
      // serviceActions.Duplicate
    ],
    Canceled: [
      serviceActions.Note,
      serviceActions.BulkSMS
      // serviceActions.Duplicate
    ],
    ManualHandled: [
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.SendToPlanning
      // serviceActions.Duplicate
    ]
  },
  Delivery: {
    InAuction: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.SendToMarket,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning
    ],
    InMarket: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.SendToMarket,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.Auction,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning
    ],
    Assigned: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning
    ],
    Unassigned: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.SendToMarket,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.Auction,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.CreateRoute,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning
    ],
    Started: [
      serviceActions.Assign,
      serviceActions.AutoAssign,
      serviceActions.AssignRoute,
      serviceActions.AssignResourceAllocation,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation,
      serviceActions.SendToPlanning
    ],
    Aborted: [
      serviceActions.AssignCanceledPickup,
      serviceActions.ReassignCanceledDropoff,
      serviceActions.Reset,
      serviceActions.Cancel,
      serviceActions.ManualHandle,
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.EditLocation,
    ],
    Completed: [
      serviceActions.Note,
      serviceActions.BulkSMS
      // serviceActions.Duplicate
    ],
    Canceled: [
      serviceActions.Note,
      serviceActions.BulkSMS
      // serviceActions.Duplicate
    ],
    ManualHandled: [
      serviceActions.Note,
      serviceActions.BulkSMS,
      serviceActions.SendToPlanning
      // serviceActions.Duplicate
    ]
  }
};

export const serviceExtraActionsByStatusMap = {
  Operation: {
    InAuction: [
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel

    ],
    InMarket: [
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel

    ],
    Assigned: [
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.CreateExpense

    ],
    Unassigned: [
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel

    ],
    Started: [
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.CreateExpense
    ],
    Aborted: [
      servicesExtraActions.Edit_Operation,
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel

    ],
    ManualHandled: [
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense
    ],
    Completed: [
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense
    ],
    Canceled: [
      servicesExtraActions.Duplicate_Operation,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea

    ]
  },
  Delivery: {
    InAuction: [
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.Dispatch_External
    ],
    InMarket: [
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.Dispatch_External

    ],
    Assigned: [
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense,
      servicesExtraActions.Dispatch_External

    ],
    Unassigned: [
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.Dispatch_External
    ],
    Started: [
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense,
      servicesExtraActions.Dispatch_External
    ],
    Aborted: [
      servicesExtraActions.Edit_Delivery,
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea
    ],
    ManualHandled: [
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense
    ],
    Completed: [
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea,
      servicesExtraActions.CreateExpense
    ],
    Canceled: [
      servicesExtraActions.Duplicate_Delivery,
      servicesExtraActions.Print,
      servicesExtraActions.PrintLabel,
      servicesExtraActions.PrintIkea
    ]
  }
};


